export default __webpack_public_path__ + "static/media/home_content_4.2d621831.png";